import { Component } from '@theme/component';

/**
 * Section-specific wrapper for the marketing hero slideshow.
 *
 * @extends {Component}
 */
export class MarketingHeroSliderComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('slideshow:select', this.#handleSlideSelect);
    this.addEventListener('play', this.#handleVideoPlay, true);
    this.#syncControls(0);

    requestAnimationFrame(() => this.#pauseInactiveVideos());
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.removeEventListener('slideshow:select', this.#handleSlideSelect);
    this.removeEventListener('play', this.#handleVideoPlay, true);
  }

  previous(event) {
    event?.preventDefault();
    this.#pauseForInteraction();
    this.slideshow?.previous(event);
  }

  next(event) {
    event?.preventDefault();
    this.#pauseForInteraction();
    this.slideshow?.next(event);
  }

  select(index, event) {
    event?.preventDefault();
    this.#pauseForInteraction();
    this.slideshow?.select(index, event);
  }

  get slideshow() {
    return this.querySelector('slideshow-component');
  }

  #pauseForInteraction() {
    this.slideshow?.pause();
  }

  #handleSlideSelect = (event) => {
    this.#syncControls(event.detail.index);
    this.#pauseInactiveVideos();
  };

  #handleVideoPlay = (event) => {
    if (!(event.target instanceof HTMLVideoElement)) return;
    if (!event.target.closest('slideshow-slide[aria-hidden="false"], .marketing-hero__slide')) return;

    this.slideshow?.pause();
  };

  #syncControls(index) {
    const dots = this.querySelectorAll('.marketing-hero__slider-dot');
    const current = this.querySelector('.marketing-hero__slider-counter [ref="current"]');

    dots.forEach((dot, dotIndex) => {
      dot.setAttribute('aria-pressed', `${dotIndex === index}`);
    });

    if (current) current.textContent = `${index + 1}`;
  }

  #pauseInactiveVideos() {
    const slides = this.querySelectorAll('slideshow-slide');

    slides.forEach((slide) => {
      const isActive = slide.getAttribute('aria-hidden') === 'false';

      if (isActive) return;

      slide.querySelectorAll('video').forEach((video) => {
        if (video instanceof HTMLVideoElement && !video.paused) video.pause();
      });
    });
  }
}

if (!customElements.get('marketing-hero-slider-component')) {
  customElements.define('marketing-hero-slider-component', MarketingHeroSliderComponent);
}
